module.exports = __webpack_public_path__ + "img/weather54.03eea68e.png";